export default __webpack_public_path__ + "static/media/service-thumb-pavers-walkway.e8e8caeb.jpg";